import { withEventScope } from '@repo/event-processor';

import InviteButtons from '../InviteButtons/InviteButtons';

import { Email, Wrapper } from './styles';
import { SentInviteProps } from './types';

/**
 * render a sent invites and buttons with actions that can be taken
 */
const SentInvite: React.FC<SentInviteProps> = ({
  email,
  canUpdate,
  onDelete,
}) => {
  return (
    <Wrapper>
      <Email noTextOverflow>{email}</Email>
      {canUpdate && <InviteButtons email={email} onDelete={onDelete} />}
    </Wrapper>
  );
};

export default withEventScope(SentInvite, { module: 'sentInvite' });
